import styled from 'styled-components'
import { sureco } from '../../shared/finance.styles'

/* Drawer row: same 80px label column as DrawerField so it lines up. */
export const EmailRow = styled.div`
  display: grid;
  grid-template-columns: 80px 1fr;
  align-items: center;
  gap: 8px;
`

export const EmailRowLabel = styled.div`
  font-size: 12px;
  font-weight: 500;
  color: ${sureco.placeholder};
`

export const EmailRowValue = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 8px;
  min-width: 0;
`

export const TemplateEditorHint = styled.span`
  display: inline-flex;
  align-items: center;
  gap: 8px;
  min-width: 0;
  font-size: 12px;
  color: ${sureco.fg3};
`

/* Capped to the window so a long email scrolls inside the frame. */
export const EmailFrame = styled.iframe`
  display: block;
  width: 100%;
  max-height: 68vh;
  border: 1px solid ${sureco.border};
  border-radius: 8px;
  background: #f5f5f5;
`

export const PreviewState = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 12px;
  min-height: 240px;
  font-size: 13px;
  color: ${sureco.fg3};
`

export const PreviewModalTitle = styled.div`
  font-size: 16px;
  font-weight: 600;
  color: ${sureco.fg1};
`

export const PreviewModalSubtitle = styled.div`
  margin-top: 2px;
  font-size: 13px;
  font-weight: 400;
  color: ${sureco.fg3};
`

export const PreviewCaption = styled.div`
  font-size: 12px;
  color: ${sureco.fg3};
  line-height: 1.5;
  margin-bottom: 12px;
`

export const PreviewHeader = styled.dl`
  display: grid;
  grid-template-columns: 64px 1fr;
  row-gap: 6px;
  column-gap: 8px;
  margin: 0 0 12px;
  padding: 12px 14px;
  background: ${sureco.pageBg};
  border: 1px solid ${sureco.border};
  border-radius: 8px;
`

export const PreviewHeaderLabel = styled.dt`
  font-size: 12px;
  font-weight: 500;
  color: ${sureco.placeholder};
`

export const PreviewHeaderValue = styled.dd<{ $isSubject?: boolean }>`
  margin: 0;
  min-width: 0;
  font-size: ${({ $isSubject }) => ($isSubject ? '13px' : '12px')};
  font-weight: ${({ $isSubject }) => ($isSubject ? 600 : 400)};
  color: ${({ $isSubject }) => ($isSubject ? sureco.fg1 : sureco.fg2)};
  line-height: 1.45;
  word-break: break-word;
`
